import { SetupIntent } from '../../../modules/payment/types';
import { createTeacherSetupIntent } from '../../../modules/teacher/api';

export const createTeacherSetupIntentUseCase = async (teacherUuid: string): Promise<SetupIntent> => {
  return createTeacherSetupIntent(teacherUuid);
};